module.exports = __webpack_public_path__ + "img/mortgages-providers.a82a2b8.webp";